import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {
      uid: String,
      is_admin: Boolean,
      email: String,
      firstname: String,
      lastname: String,
      image: String,
    },
  },
  mutations: {
    addUser(state, user) {
      state.user.uid = user.uid;
      state.user.is_admin = user.is_admin;
      state.user.email = user.email;
      state.user.firstname = user.firstname;
      state.user.lastname = user.lastname;
      state.user.image = user.image;
    },
    removeUser(state) {
      state.user = {}
    },
    updatePicture(state, url) {
      state.user.image = url;
    },
    updateFirstname(state, message) {
      state.user.firstname = message
    },
    updateLastname(state, message) {
      state.user.lastname = message
    }
  },
  actions: {},
  modules: {}
})
